import {
  postJsonRequest,
  getJsonRequest,
  patchJsonRequest,
  deleteJsonRequest,
} from "Helpers/ApiRequest";
import Cookies from "universal-cookie";

const getAuth = () => new Cookies().get("token");
export const authorizedGet = (params: any) =>
  getJsonRequest({
    ...params,
    headers: { Authorization: `Bearer ${getAuth()}` },
  });
export const authorizedPost = ({ url, body }: { url: string; body: any }) =>
  postJsonRequest({
    url,
    body,
    headers: { Authorization: `Bearer ${getAuth()}` },
  });
export const authorizedPatch = ({ url, body }: { url: string; body: any }) =>
  patchJsonRequest({
    url,
    body,
    headers: { Authorization: `Bearer ${getAuth()}` },
  });
export const authorizedDelete = ({ url, body }: { url: string; body: any }) =>
  deleteJsonRequest({
    url,
    body,
    headers: { Authorization: `Bearer ${getAuth()}` },
  });
